"use strict";

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.axiosInstance = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _cookie2 = _interopRequireDefault(require("@zz-common/zz-utils/lib/cookie"));

var _env2 = _interopRequireDefault(require("@zz-common/zz-utils/lib/env"));

require("core-js/modules/es.array.find-index.js");

require("core-js/modules/es.array.splice.js");

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.promise.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.object.assign.js");

require("core-js/modules/es.array.join.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array-buffer.constructor.js");

require("core-js/modules/es.array-buffer.slice.js");

var _axios = _interopRequireDefault(require("axios"));

var _jsonp = _interopRequireDefault(require("jsonp"));

var _stringify = _interopRequireDefault(require("./qs/stringify"));

var _jsb = require("./jsb");

var _apiCache = _interopRequireDefault(require("./apiCache"));

var _utils = require("./jsb/utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var cache = {}; // 请求禁用标记， 用于控制是否允许请求发送

var forbid = cache['@zz/fetch/vars/forbind'] || (cache['@zz/fetch/vars/forbind'] = {
  current: false
}); // 首次请求标记

var firstFetch = true;

var axiosInstance = _axios.default.create();

exports.axiosInstance = axiosInstance;
var DEFAULT_CONTENT_TYPE = "application/x-www-form-urlencoded";
var defaultConfig = {
  method: "get",
  responseType: "json",
  timeout: 0,
  withCredentials: true,
  maxContentLength: 2000,
  beforeRequest: function beforeRequest() {},
  beforeResponse: function beforeResponse() {},
  transformRequest: [function (data) {
    return data;
  }],
  transformResponse: [function (data) {
    return data;
  }],
  headers: {
    "Content-Type": DEFAULT_CONTENT_TYPE
  }
}; // 缓存所有请求 / 用于寻找相同请求 url
// 待优化: 需要限制队列最大长度

var pendingAjax = [];
var cancelType = 2; // 0表示取消后续重复请求，1表示使用最后一次请求的数据，2表示不处理重复请求

var FAST_CLICK_MSG = "数据请求中，请稍候";
var CancelToken = _axios.default.CancelToken;
var CANCEL_TEXT = "USER CANCEL"; // 处理请求中的ajax

function handlePendingAjax(config, c) {
  if (!config) return;
  var url = config.url + JSON.stringify(config.params) + JSON.stringify(config.data);
  var index = pendingAjax.findIndex(function (i) {
    return i.url === url;
  });

  if (cancelType === 0) {
    if (index > -1) {
      c ? c(FAST_CLICK_MSG) : pendingAjax.splice(index, 1);
    } else {
      c && pendingAjax.push({
        url: url,
        c: c
      });
    }
  } else if (cancelType === 1) {
    if (index > -1) {
      c && pendingAjax[index].c(FAST_CLICK_MSG);
      pendingAjax.splice(index, 1);
    }

    c && pendingAjax.push({
      url: url,
      c: c
    });
  }
}

var isAndroid444 = _env2.default.getAndroidVersion() == "4.4.4"; // request 拦截器

axiosInstance.interceptors.request.use(function (config) {
  var cancel;

  if ([0, 1].includes(cancelType)) {
    config.cancelToken = new CancelToken(function (c) {
      handlePendingAjax(config, c);

      cancel = function cancel() {
        return c(CANCEL_TEXT);
      };
    });
  } else {
    config.cancelToken = new CancelToken(function (c) {
      cancel = function cancel() {
        return c(CANCEL_TEXT);
      };
    });
  }

  config.beforeRequest && config.beforeRequest(config, cancel); // logInfo('config.csrfToken', config.csrfToken !== false);

  if (config.csrfToken !== false) {
    // 每次请求获取最新的TT值
    try {
      var TT = _cookie2.default.getPPU().TT || "";

      if (!isAndroid444 && TT) {
        config.headers["Csrf-Token"] = TT;
      }
    } catch (error) {
      (0, _utils.logWarn)(error);
    }
  }

  (0, _utils.logInfo)('interceptors.request', config);
  return config;
}, function (error) {
  return Promise.reject(error);
}); // response 拦截器

axiosInstance.interceptors.response.use(function (response) {
  handlePendingAjax(response.config);

  try {
    (0, _utils.logInfo)('interceptors-response', response.data);
    var data = response.data || {};

    if (typeof data === "string" && data.indexOf("{") === 0) {
      response.data = JSON.parse(data);
    }
  } catch (error) {}

  response.config.beforeResponse && response.config.beforeResponse(response);
  return response;
}, function (error) {
  if (error.message !== FAST_CLICK_MSG) {
    // 非重复点击导致的请求失败需要清除pendingAjax
    pendingAjax.splice(0, pendingAjax.length);
  } else {
    error.type = "Cancel";
  }

  return Promise.reject(error);
});

var needSerializer = function needSerializer(contentType) {
  return contentType === DEFAULT_CONTENT_TYPE;
};

var needStringify = function needStringify(contentType) {
  return contentType === "application/json";
};

var zzaxios = function zzaxios(opts) {
  var isPost = opts.method && opts.method.toLowerCase() === "post";
  var params = opts.params || {};
  var isUseData = !!opts.isUseData;
  var contentType = opts.format || DEFAULT_CONTENT_TYPE;
  cancelType = opts.cancelType === undefined ? cancelType : opts.cancelType;
  var config = Object.assign({}, defaultConfig, _objectSpread(_objectSpread({}, opts), {}, {
    params: isPost || isUseData ? {} : params,
    data: isPost || isUseData ? needSerializer(contentType) ? (0, _stringify.default)(params) : needStringify(contentType) ? JSON.stringify(params) : params : {},
    headers: _objectSpread(_objectSpread({}, opts.headers), {}, {
      // 如果有传入指定的content-type，那么修改默认的content-type
      "Content-Type": contentType + '; charset=utf-8'
    })
  }));

  if (config.method.toLowerCase() === "get" && config.cache) {
    return new Promise(function (res, rej) {
      (0, _apiCache.default)(axiosInstance, config.expires).get(config.url, config).then(function (r) {
        res(r.data);
      }).catch(function (err) {
        rej(err);
      });
    });
  } else {
    return new Promise(function (res, rej) {
      axiosInstance(config).then(function (r) {
        //  logInfo('axiosInstance.then', r)
        res(r.data);
      }).catch(function (err) {
        //  logInfo('axiosInstance.catch', err)
        rej(err);
      });
    });
  }
};

var formatUrlQuery = function formatUrlQuery(url, params) {
  var query = url.indexOf("?") === -1 ? "?" : "&";
  query += Object.keys(params).map(function (key) {
    return "".concat(key, "=").concat(encodeURIComponent((0, _typeof2.default)(params[key]) === 'object' ? JSON.stringify(params[key]) : params[key]));
  }).join("&");

  if (Object.keys(params).length == 0) {
    query = "";
  }

  return url + query;
};

var zznative = function zznative(opts) {
  (0, _utils.logInfo)('zz-fetch: zznative');

  var originOpts = _objectSpread({}, opts);

  var params = opts.params || {};
  var method = opts.method.toLowerCase() || 'get';
  var contentType = opts.format || DEFAULT_CONTENT_TYPE;
  cancelType = opts.cancelType === undefined ? cancelType : opts.cancelType;
  var config;

  if (opts.csrfToken !== false) {
    // 每次请求获取最新的TT值
    try {
      var TT = _cookie2.default.getPPU().TT || "";

      if (!isAndroid444 && TT) {
        if (!opts.headers) opts.headers = {};
        opts.headers["Csrf-Token"] = TT;
      }
    } catch (error) {
      (0, _utils.logWarn)(error);
    }
  }

  if (method === 'get') {
    opts.url = formatUrlQuery(opts.url, params);
    config = Object.assign({}, defaultConfig, _objectSpread(_objectSpread({}, opts), {}, {
      headers: _objectSpread(_objectSpread({}, opts.headers), {}, {
        // 如果有传入指定的content-type，那么修改默认的content-type
        "Content-Type": contentType
      })
    }));
    delete config.params;
    delete config.body;
    delete config.format;
  } else if (method === 'post') {
    if (params && (params instanceof FormData || params instanceof ArrayBuffer || params instanceof Blob)) {
      throw Error('该 post body native 不支持');
    }

    config = Object.assign({}, defaultConfig, _objectSpread(_objectSpread({}, opts), {}, {
      body: params,
      headers: _objectSpread(_objectSpread({}, opts.headers), {}, {
        // 如果有传入指定的content-type，那么修改默认的content-type
        "Content-Type": contentType
      })
    }));
    delete config.params;
    delete config.format;
  } else {
    // throw Error('该 method 方法 native 不支持')
    (0, _utils.logInfo)('该 method 方法 native 不支持', opts.url);
    return zzaxios(originOpts);
  }

  (0, _utils.logInfo)('config', config);
  if (config.beforeRequest) config.beforeRequest(config);
  var promise = Promise.resolve(config);
  promise = promise.then(_jsb.checkAppSupport);
  promise = promise.then(function (req) {
    if (req.noSupport) return zzaxios(originOpts);
    return (0, _jsb.callNativeAjax)(req);
  });
  return promise;
};

var zzjsonp = function zzjsonp(opts) {
  var url = opts.url,
      _opts$params = opts.params,
      params = _opts$params === void 0 ? {} : _opts$params;

  var _url = formatUrlQuery(url, params);

  return new Promise(function (resolve, reject) {
    var wrapJsonp = {
      jsonp: _jsonp.default
    };

    if (opts.cache) {
      wrapJsonp = (0, _apiCache.default)(wrapJsonp, opts.expires);
    }

    wrapJsonp.jsonp(_url, {
      timeout: opts.timeout || 0,
      name: opts.callback,
      prefix: opts.prefix
    }, function (err, res) {
      if (err) {
        reject(err);
      } else {
        var data = res;

        if (typeof data === "string" && data.indexOf("{") === 0) {
          data = JSON.parse(data);
        }

        resolve(data);
      }
    });
  });
};

var zzfetch = function zzfetch() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  firstFetch && console.log('小提示：可配置 window[\'__@zz/fetch__dev__\']=true 查看 @zz/fetch 详细日志');
  firstFetch = false; // method  native

  var _opts$method = opts.method,
      method = _opts$method === void 0 ? 'get' : _opts$method,
      url = opts.url,
      _native = opts.native;

  if (forbid.current) {
    (0, _utils.logWarn)('请求被禁用, 请确认配置');
    return Promise.reject();
  }

  if (!url) {
    (0, _utils.logWarn)('error，请检查入参url');
    throw new Error("error，请检查入参url");
  }

  if (method.toLowerCase() === 'jsonp') {
    return zzjsonp(opts);
  } else if (_native === true) {
    return zznative(opts);
  } else {
    return zzaxios(opts);
  }
};

zzfetch.getAxiosInterceptors = function () {
  (0, _utils.logInfo)('该拦截器仅支持 ajax 请求，不支持 jsonp 和 native');
  return axiosInstance.interceptors;
};

zzfetch.setForbidFlag = function (val) {
  forbid.current = val;
};

var _default = zzfetch;
exports.default = _default;